import React, { Component } from "react";
import { Popup } from "semantic-ui-react";
import NotifcationPanel from "./componenets/NotifcationPanel";
import NotificationIcon from "./componenets/NotificationIcon";

class NotificationsIndicator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }
  handleOpen() {
    this.setState(prevState => ({ ...prevState, isOpen: true }));
  }
  handleClose() {
    this.setState(prevState => ({ ...prevState, isOpen: false }));
  }
  render() {
    const { isOpen } = this.state;
    return (
      <Popup
        trigger={<NotificationIcon />}
        on="click"
        open={isOpen}
        onClose={this.handleClose}
        onOpen={this.handleOpen}
        className="notification-panel-wrapper"
        content={<NotifcationPanel closePopup={this.handleClose} />}
      />
    );
  }
}

export default NotificationsIndicator;



// WEBPACK FOOTER //
// ./src/components/Header/Components/NotificationsIndicator/index.js